import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '../theme';
import { isolateMixin } from '../utils/mixins';

var styles = function styles(theme) {
  return {
    sideNav: {
      extend: isolateMixin,
      fontFamily: theme.fontFamily,
      display: 'inline-block'
    },
    block: {
      display: 'block'
    }
  };
};

var SideNav = /*#__PURE__*/function (_Component) {
  _inherits(SideNav, _Component);

  var _super = _createSuper(SideNav);

  function SideNav() {
    var _this;

    _classCallCheck(this, SideNav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.value = _this.props.value;
    _this.state = {
      value: _this.value
    };

    _this.onValueChange = function (event, value) {
      _this.setValue(value);

      if (_this.props.onChange) _this.props.onChange(event, value);
    };

    return _this;
  }

  _createClass(SideNav, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;
      if (value !== prevProps.value) this.setValue(value);
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      if (value !== this.value) {
        this.value = value;
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          size = _this$props.size,
          block = _this$props.block,
          children = _this$props.children,
          className = _this$props.className,
          classes = _this$props.classes,
          theme = _this$props.theme,
          value = _this$props.value,
          other = _objectWithoutProperties(_this$props, ["size", "block", "children", "className", "classes", "theme", "value"]);

      var resultChildren = Children.map(children, function (child) {
        if (!child.type || child.type.displayName !== 'RamblerUI(SideNavItem)') throw new Error('Child component should be instance of <SideNavItem />');
        var hasValue = 'value' in child.props;
        var isSelected = hasValue && child.props.value === _this2.state.value;
        return cloneElement(child, _extends({
          size: size,
          isSelected: isSelected
        }, hasValue && {
          onPress: _this2.onValueChange
        }));
      });
      var resultClassName = classnames(classes.sideNav, className, block && classes.block);
      return React.createElement("div", _extends({}, other, {
        className: resultClassName
      }), resultChildren);
    }
  }]);

  return SideNav;
}(Component);

SideNav.defaultProps = {
  value: null,
  block: false,
  size: 'medium'
};
SideNav.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Класс контейнера
   */
  className: PropTypes.string,

  /**
   * CSS-стили навигации
   */
  style: PropTypes.object,

  /**
   * Элементы навигации, обязаны быть компонентами типа `<SideNavItem/>`
   */
  children: PropTypes.node,

  /**
   * Размер компонента:
   * `small` - только иконки
   * `medium` - иконки с текстом
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Выбранное значение навигации
   */
  value: PropTypes.any,

  /**
   * Отображать навигацию как блочный элемент (т.е. он будет растянут на всю ширину родительского элемента)
   */
  block: PropTypes.bool,

  /**
   * Функция, вызывающая при изменении значения `function (event: object, newValue: any) {}`
   */
  onChange: PropTypes.func
} : {};
export default withStyles(styles, {
  name: 'SideNav'
})(SideNav);